import { render } from "./DotsonTable.vue?vue&type=template&id=33a70779&scoped=true"
import script from "./DotsonTable.vue?vue&type=script&lang=js"
export * from "./DotsonTable.vue?vue&type=script&lang=js"

import "./DotsonTable.vue?vue&type=style&index=0&id=33a70779&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33a70779"]])

export default __exports__